import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../hooks/useMetaPixel';
export function OfferSection() {
  const items = [{
    name: 'Ebook principal "Vuelve a Brillar con IA"',
    value: 47
  }, {
    name: 'Diario de Gratitud y Manifestación',
    value: 19
  }, {
    name: 'Guía de herramientas de IA',
    value: 27
  }, {
    name: 'Checklist Método Orgánico',
    value: 17
  }];
  return <section id="offer" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0d0b14] via-purple-950 to-pink-950/50 text-white relative overflow-hidden" data-id="element-174">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-175"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="sm:text-5xl font-bold mb-6 text-white text-[40px]" data-id="element-178">
            Todo lo que recibirás por comprar hoy:
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/[0.07] backdrop-blur-sm text-white rounded-3xl p-8 sm:p-12 shadow-2xl border border-white/10" data-id="element-179">
          <div className="space-y-4 mb-8" data-id="element-180">
            {items.map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 pb-4 last:border-0" data-id="element-181">
                <span className="text-lg font-medium text-slate-200" data-id="element-182">
                  {item.name}
                </span>
                <span className="text-lg text-slate-500 line-through" data-id="element-183">
                  US${item.value}
                </span>
              </div>)}
          </div>

          <div className="flex justify-between items-center mb-8 pt-4 border-t-2 border-white/10" data-id="element-184">
            <span className="text-xl font-bold text-slate-400" data-id="element-185">
              Valor total:
            </span>
            <span className="text-2xl font-bold text-slate-500 line-through" data-id="element-186">
              US$110
            </span>
          </div>

          <div className="text-center bg-pink-500/15 rounded-2xl p-8 mb-8 border border-pink-500/25" data-id="element-187">
            <p className="font-bold text-xl mb-2 text-[#65CA13]" data-id="element-188">Precio hoy:</p>
            <div className="text-6xl sm:text-7xl font-extrabold mb-4 text-[#F1EDED]" data-id="element-189">
              US$19
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-190">
            <p className="text-lg text-slate-300 font-medium" data-id="element-191">
              No estás comprando solo un ebook.
              <br data-id="element-192" />
              Estás accediendo a un sistema que combina mentalidad, hábitos y
              herramientas para ayudarte a crear una nueva etapa en tu vida.
            </p>
          </div>

          <motion.a href="https://pay.hotmart.com/R104785188L" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart')} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="block w-full py-5 bg-gradient-primary text-white rounded-full font-bold text-xl shadow-xl shadow-pink-500/40 hover:shadow-pink-500/60 transition-all text-center" data-id="element-193">
            QUIERO ACCEDER AL KIT
          </motion.a>
        </motion.div>
      </div>
    </section>;
}